export default __webpack_public_path__ + "img/soundcloud.58cb63ec17872278a87939a4705ae488.svg";